import ApiService from "./api.service";
let main = "region";
export default {
  uzbRegions() {
    return ApiService.get(`${main}/list-uzb-region`);
  },
};
